const getters = {
  origin: state => {
    return state.siteConfig.origin
  },
}
export default getters
